import React, { useEffect, useRef, useState } from "react";
import LocationIcon from "../assets/icons/icon_the_street/location.svg"
import TempIcon from "../assets/icons/icon_the_street/temp.svg"
import HumidityIcon from "../assets/icons/icon_the_street/humidity.svg"
import IonIcon from "../assets/icons/icon_the_street/ion.svg"
import TvocIcon from "../assets/icons/icon_the_street/tvoc.svg"
import Pm25Icon from "../assets/icons/icon_the_street/pm25.svg"
import Co2Icon from "../assets/icons/icon_the_street/co2.svg"
import AqiGoodFace from "../assets/icons/icon_the_street/aqi_1.svg"
import AqiModerateFace from "../assets/icons/icon_the_street/aqi_2.svg"
import AqiSensitiveFace from "../assets/icons/icon_the_street/aqi_3.svg"
import AqiUnHealthyFace from "../assets/icons/icon_the_street/aqi_4.svg"
import AqiVeryUnHealthyFace from "../assets/icons/icon_the_street/aqi_5.svg"
import AqiHazadousFace from "../assets/icons/icon_the_street/aqi_6.svg"
import AqiGoodBand from "../assets/icons/icon_the_street/aqi_band_1.svg"
import AqiModerateBand from "../assets/icons/icon_the_street/aqi_band_2.svg"
import AqiSensitiveBand from "../assets/icons/icon_the_street/aqi_band_3.svg"
import AqiUnHealthyBand from "../assets/icons/icon_the_street/aqi_band_4.svg"
import AqiVeryUnHealthyBand from "../assets/icons/icon_the_street/aqi_band_5.svg"
import AqiHazadousBand from "../assets/icons/icon_the_street/aqi_band_6.svg"
import Logo from "../assets/icons/icon_the_street/logo.png"

import { numberWithCommas } from "../services/helper";
import { getDataTheStreetAPI } from "../services/api";
import TestBgIndoor from "../assets/icons/icon_the_street/indoor_green.mp4"
import TestBgOutdoor from "../assets/icons/icon_the_street/outdoor_green.mp4"
import TestBgIndoorJpg from "../assets/icons/icon_the_street/indoor_good.jpg"
import TestBgOutdoorJpg from "../assets/icons/icon_the_street/outdoor_good.jpg"


function pad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
}
function getAqiFace(level) {
    if (level == "good") return AqiGoodFace
    if (level == "moderate") return AqiModerateFace
    if (level == "unhealthy for sensitive groups") return AqiSensitiveFace
    if (level == "unhealthy") return AqiUnHealthyFace
    if (level == "very unhealthy") return AqiVeryUnHealthyFace
    if (level == "hazadous") return AqiHazadousFace
    return ""
}
function getAqiBand(level) {
    if (level == "good") return AqiGoodBand
    if (level == "moderate") return AqiModerateBand
    if (level == "unhealthy for sensitive groups") return AqiSensitiveBand
    if (level == "unhealthy") return AqiUnHealthyBand
    if (level == "very unhealthy") return AqiVeryUnHealthyBand
    if (level == "hazadous") return AqiHazadousBand
    return ""
}
function getAqiTextFontSize(level, site) {
    if (level == "very unhealthy") return site == "indoor" ? "194px" : "100px"
    return site == "indoor" ? "160px" : "112px"
}
// const mock_res = {
//     indoor: {
//         location_name: "Plenary Hall",
//         background: TestBgIndoorJpg,
//         temp: 25,
//         humidity: 55,
//         aqi_value: 15,
//         aqi_text: "Good",
//         ion_value: 120000,
//         ion_text: "   The higher ions,   the better air quality.",
//         pm25_value: 10,
//         pm25_text: "Good",
//         co2_value: 100,
//         co2_text: "Good",
//         tvoc_value: 10,
//         tvoc_text: "Good"
//     },
//     outdoor: {
//         location_name: "",
//         background: TestBgOutdoorJpg,
//         temp: 26,
//         humidity: 60,
//         aqi_value: 15,
//         aqi_text: "Good",
//         ion_value: 120000,
//         ion_text: "",
//         pm25_value: 10,
//         pm25_text: "Good",
//         co2_value: 100,
//         co2_text: "Good"
//     }
// }

export default function THE_STREET() {
    const [data, setData] = useState(null);

    const outdoorVideoRef = useRef()
    const indoorVideoRef = useRef()

    const VIDEO_WIDTH = 1400

    const loadData = () => {
        getDataTheStreetAPI({}, (res) => {
            if (res.indoor.aqi_value !== 0 || data == null) {
                setData(res)
                outdoorVideoRef.current.src = res?.outdoor?.background
                indoorVideoRef.current.src = res?.indoor?.background
            }
        }, (err) => {
            console.log(err)
        });

    }

    useEffect(() => {
        loadData()
        const interval = setInterval(loadData, 60000);
        return () => clearInterval(interval)
    }, [])

    return (
        <>
            {data && <div class="qnscc-font" style={{
                width: "100%",
                minWidth: "1080px",
                height: "1920px",
                display: "flex",
                flexDirection: "row",
                background: "#010101"
            }}>
                <div style={{ width: "100%", color: "#ffffff" }}>
                    <div class="row m-0 p-0 w-100" style={{ height: "72.5%", overflow: "hidden" }}>
                        <div id="indoor" class="m-0 p-0" style={{ width: "100%" }}>
                            <div class="w-100 d-flex justify-content-between align-items-center" style={{ height: "160px", padding: "0 2.25rem", position: "absolute", background: "rgba(0, 0, 0, 0.53)", fontSize: "66px" }}>
                                <div>Air Quality Dashboard</div>
                                <img alt="" src={Logo} height="150" />
                            </div>
                            <div class="row w-100 d-flex flex-column m-0" style={{ textAlign: "start", paddingLeft: "2.25rem", paddingRight: "2.25rem", paddingTop: "185px", position: "absolute" }}>
                                <div id="indoor-header-box" class="w-100 d-flex justify-content-between align-items-center p-0">
                                    <div id="indoor-header" style={{ fontSize: 60, lineHeight: "50px" }}>Indoor Air Quality</div>
                                </div>
                                <div class="w-100 d-flex justify-content-between align-items-center " style={{ marginTop: "50px", width: "90%"}}>
                                    <div id="the-street-header" style={{ fontSize: 60, lineHeight: "50px", padding: "0 2.25rem" }}>THE STREET</div>
                                    <div class="d-flex" style={{padding: "0 2.25rem"}}>
                                        <div id="indoor-temp" class="d-flex px-3" style={{ fontSize: "60px", lineHeight: "70px" }}>
                                            <img class="px-2" alt="" src={TempIcon} height="90" />
                                            <div>{data.indoor.temp} °c</div>
                                        </div>
                                        <div id="indoor-humidity" class="d-flex" style={{ fontSize: "60px", lineHeight: "70px" }}>
                                            <img class="px-2" alt="" src={HumidityIcon} height="90" />
                                            <div>{data.indoor.humidity} %</div>
                                        </div>
                                    </div>
                                </div>
                                <div id="indoor-loc" class="d-flex p-0" style={{ paddingTop: "13px"}}>
                                    {/* <img alt="" src={LocationIcon} height="74" />
                                    <span style={{ fontSize: "84px", marginTop: "-10px", marginLeft: "13px" }}>{data.indoor.location_name}</span> */}
                                </div>
                                <div id="indoor-aqi" class="d-flex justify-content-between align-items-center mx-auto" style={{ width: "90%", paddingTop: "60px" }}>
                                    <img alt="" src={getAqiFace(data.indoor.aqi_text.toLowerCase())} height="280" style={{ marginLeft: "-27px" }} />
                                    <div id="indoor-aqi-detail" class="d-flex flex-column" style={{ lineHeight: "90px", paddingRight: "100px" }}>
                                        <div style={{ fontSize: getAqiTextFontSize(data.indoor.aqi_text.toLowerCase(), "indoor"), marginRight: "-40%" }}>
                                            {data.indoor.aqi_text.toLowerCase() == "unhealthy for sensitive groups" ? "UNHEALTHY" : data.indoor.aqi_text.toUpperCase()}
                                            {data.indoor.aqi_text.toLowerCase() == "unhealthy for sensitive groups" && <div class="mx-2" style={{ fontSize: "20px", marginTop: "-15px" }}>For sensitive groups</div>}
                                        </div>
                                        <div id="indoor-aqi-value" class="d-flex mb-2">
                                            <div style={{ fontSize: "60px", width: "100px" }}>AQI</div>
                                            <div style={{ fontSize: "75px" }}>{numberWithCommas(data.indoor.aqi_value)}</div>
                                        </div>
                                        <img alt="" src={getAqiBand(data.indoor.aqi_text.toLowerCase())} height="65" />
                                    </div>
                                </div>
                                <div id="indoor-pm25" class="qsncc-box d-flex flex-column mx-auto mt-2" style={{ width: "90%", height: "120px" }}>
                                    <div id="indoor-pm25-title" class="d-flex" style={{ height: "110px" }}>
                                        <div class="d-flex h-100 justify-content-center align-items-center " style={{ width: "30%", fontSize: "38px", lineHeight: "45px" }}>
                                            <img alt="" src={Pm25Icon} height="90" />
                                            <div style={{ fontSize: "80px" }}>PM 2.5</div>
                                        </div>
                                        <div class="d-flex flex-column h-100 justify-content-center align-items-center " style={{ width: "40%", fontSize: "72px", lineHeight: "60px" }}>
                                            <div>{numberWithCommas(data.indoor.pm25_value)}</div>
                                            <div style={{ fontSize: "40px", lineHeight: "24px" }}>ug/m<sup>3</sup></div>
                                        </div>
                                        <div class="h-100 text-center d-flex align-items-center" style={{ width: "30%", fontSize: "80px", lineHeight: "24px", wordWrap: "break-word", whiteSpace: "break-spaces" }}>
                                            {data.indoor.pm25_text}
                                        </div>
                                    </div>
                                    {/* <div style={{ height: "30px", fontSize: "20px" }}>The ion quality is reflected by the air quality. The higher the ion quantity, the higher possibility of better air quality.</div> */}
                                </div>
                                <div class="d-flex justify-content-between p-0 mx-auto mt-1" style={{ width: "90%", height: "400px" }}>
                                    <div id="indoor-c02" class="qsncc-box h-100 d-flex flex-column text-center" style={{ width: "48%" }}>
                                        <div id="indoor-co2-title" class="d-flex pt-3" style={{ height: "80px" }}>
                                            <div class="w-100 d-flex justify-content-center align-items-center " style={{ fontSize: "80px", lineHeight: "80px" }}>
                                                <img alt="" src={Co2Icon} height="90" />
                                                <div style={{ marginLeft: "8px" }}>CO<sub>2</sub></div>
                                            </div>
                                        </div>
                                        <div class="w-100" style={{ fontSize: "80px", lineHeight: "100px", fontWeight: "bold" }}>{data.indoor.co2_text}</div>
                                        <div class="w-100 pt-2" style={{ fontSize: "80px", lineHeight: "80px" }}>{numberWithCommas(data.indoor.co2_value)}</div>
                                        <div class="w-100" style={{ fontSize: "60px", lineHeight: "90px" }}>ppm</div>
                                    </div>
                                    <div id="indoor-tvoc" class="qsncc-box h-100 d-flex flex-column text-center" style={{ width: "48%" }}>
                                        <div id="indoor-tvoc-title" class="d-flex pt-3" style={{ height: "80px" }}>
                                            <div class="w-100 d-flex justify-content-center align-items-center " style={{ fontSize: "80px", lineHeight: "80px" }}>
                                                <img alt="" src={Pm25Icon} height="90" />
                                                <div style={{ marginLeft: "8px" }}>PM 10</div>
                                            </div>
                                        </div>
                                        <div class="w-100" style={{ fontSize: "80px", lineHeight: "100px", fontWeight: "bold" }}>{data.indoor.pm10_text}</div>
                                        <div class="w-100 pt-2" style={{ fontSize: "80px", lineHeight: "80px" }}>{numberWithCommas(data.indoor.pm10_value)}</div>
                                        <div class="w-100" style={{ fontSize: "60px", lineHeight: "90px" }}>mg/m<sup>3</sup></div>
                                    </div>
                                </div>
                                <div id="warning_text" class="w-100 d-flex justify-content-center align-items-center " style={{ width: "80%", marginTop: "30px"}}>
                                    <div style={{ fontSize: 25, lineHeight: "25px"}}>คุณภาพอากาศที่ดี PM2.5 ไม่ควรเกิน 25 ug/m<sup>3</sup> ตามประกาศกรมควบคุมมลพิษ เรื่อง ดัชนีคุณภาพอากาศของประเทศไทย พ.ศ. 2566 </div>
                                </div>
                                <div id="warning_text2" class="w-100 d-flex justify-content-center align-items-center " style={{ width: "80%", marginTop: "20px"}}>
                                    <div style={{ fontSize: 25, lineHeight: "25px"}}>และ CO<sub>2</sub> ในอาคารไม่ควรเกิน 1,000 ppm ตาม ประกาศกรมอนามัย เรื่อง ค่าเฝ้าระวังคุณภาพอากาศภายในอาคารสาธารณะ พ.ศ. 2565</div>
                                </div>
                            </div>
                            <img alt="indoor-background" ref={indoorVideoRef} src="" width={VIDEO_WIDTH} />
                            {/* <video ref={indoorVideoRef} autoPlay loop muted width={VIDEO_WIDTH} >
                                <source src={TestBgIndoor} type="video/mp4" />
                            </video> */}
                        </div>
                    </div>
                    <div class="row m-0 p-0" style={{ width: "100%", height: "32.5%", overflow: "hidden" }}>
                        <div id="outdoor" class="p-0" style={{ width: "100%" }}>
                            <div class="row w-100 d-flex flex-column m-0" style={{ textAlign: "start", paddingLeft: "2.25rem", paddingRight: "2.25rem", paddingTop: "40px", position: "absolute" }}>
                                <div id="outdoor-header-box" class="d-flex justify-content-between align-items-center p-0">
                                    <div id="outdoor-header" style={{ fontSize: 52, lineHeight: "25px" }}>Outdoor Air Quality</div>
                                    <div class="d-flex" style={{ padding: "0 2.25rem" }}>
                                        <div id="outdoor-temp" class="d-flex px-3" style={{ fontSize: "70px", lineHeight: "70px" }}>
                                            <img class="px-2" alt="" src={TempIcon} height="70" />
                                            <div>{data.outdoor.temp} °c</div>
                                        </div>
                                        <div id="outdoor-humidity" class="d-flex" style={{ fontSize: "70px", lineHeight: "70px" }}>
                                            <img class="px-2" alt="" src={HumidityIcon} height="70" />
                                            <div>{data.outdoor.humidity} %</div>
                                        </div>
                                    </div>
                                </div>
                                <div id="outdoor-content" class="d-flex justify-content-start mx-auto p-0" style={{ marginTop: "40px", width: "90%" }}>
                                    <div id="outdoor-aqi" class="d-flex pt-2 justify-content-start align-items-center" style={{ width: "70%" }}>
                                        <img alt="" src={getAqiFace(data.outdoor.aqi_text.toLowerCase())} height="180" style={{ marginLeft: "-15px" }} />
                                        <div id="outdoor-aqi-detail" class="d-flex flex-column" style={{ }}>
                                            <div style={{ fontSize: getAqiTextFontSize(data.outdoor.aqi_text.toLowerCase(), "outdoor"), marginRight: "-40%" }}>
                                                {data.outdoor.aqi_text.toLowerCase() == "unhealthy for sensitive groups" ? "UNHEALTHY" : data.outdoor.aqi_text.toUpperCase()}
                                                {data.outdoor.aqi_text.toLowerCase() == "unhealthy for sensitive groups" && <div style={{ fontSize: "25px", marginTop: "-15px" }}>For sensitive groups</div>}
                                            </div>
                                            <div id="outdoor-aqi-value" class="d-flex mb-3" style={{ lineHeight: "42px" }}>
                                                <div style={{ fontSize: "50px", width: "90px" }}>AQI</div>
                                                <div style={{ fontSize: "50px" }}>{numberWithCommas(data.outdoor.aqi_value)}</div>
                                            </div>
                                            <img alt="" src={getAqiBand(data.outdoor.aqi_text.toLowerCase())} height="40" style={{ marginTop: "17.5px", marginLeft: "-120px" }} />
                                        </div>
                                    </div>
                                    <div style={{ width: "60%" }}>
                                        <div id="outdoor-pm25" class="qsncc-box d-flex flex-column mx-auto mt-3 px-2" style={{ height: "80px" }}>
                                            <div id="outdoor-pm25-title" class="d-flex flex-column h-100" >
                                                <div class="d-flex justify-content-between align-items-center" style={{ height: "70px", fontSize: "60px" }}>
                                                    <img alt="" src={Pm25Icon} height="80" style={{ marginLeft: "-7.5px" }} />
                                                    <div style={{ marginLeft: "-4px" }}>PM 2.5</div>
                                                    <div style={{ marginLeft: "4px", fontSize: "60px", marginTop: "-2.5px" }}>{numberWithCommas(data.outdoor.pm25_value)}</div>
                                                </div>
                                                <div class="d-flex flex-column h-100 justify-content-center align-items-center pl-4" style={{ marginTop: "-10px" }} >
                                                    <div class="w-100 d-flex justify-content-end" style={{ fontSize: "20px", lineHeight: "6px" }}>ug/m<sup>3</sup></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between p-0 mx-auto mt-1" style={{ height: "250px" }}>
                                            <div id="outdoor-co2" class="qsncc-box h-100 d-flex flex-column text-center" style={{ width: "52%" }}>
                                                <div id="outdoor-co2-title" class="d-flex" style={{ height: "80px" }}>
                                                    <div class="w-100 d-flex justify-content-center align-items-center " style={{ fontSize: "50px", lineHeight: "60px" }}>
                                                        <img alt="" src={Co2Icon} height="45" />
                                                        <div>CO<sub>2</sub></div>
                                                    </div>
                                                </div>
                                                <div class="w-100" style={{ fontSize: "54px", lineHeight: "60px" }}>{data.outdoor.co2_text}</div>
                                                <div class="w-100 pt-1" style={{ fontSize: "54px", lineHeight: "60px" }}>{numberWithCommas(data.outdoor.co2_value)}</div>
                                                <div class="w-100 pb-2" style={{ fontSize: "24px", lineHeight: "20px" }}>ppm</div>
                                            </div>
                                            <div id="outdoor-co" class="qsncc-box h-100 d-flex flex-column text-center" style={{ width: "47%" }}>
                                                <div id="outdoor-co-title" class="d-flex" style={{ height: "80px" }}>
                                                    <div class="w-100 d-flex justify-content-center align-items-center " style={{ fontSize: "50px", lineHeight: "60px" }}>
                                                        <img alt="" src={Co2Icon} height="45" />
                                                        <div>CO</div>
                                                    </div>
                                                </div>
                                                <div class="w-100" style={{ fontSize: "54px", lineHeight: "60px" }}>{data.outdoor.co_text}</div>
                                                <div class="w-100 pt-1" style={{ fontSize: "54px", lineHeight: "60px" }}>{numberWithCommas(data.outdoor.co_value)}</div>
                                                <div class="w-100 pb-2" style={{ fontSize: "24px", lineHeight: "20px" }}>ppm</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img alt="outdoor-background" ref={outdoorVideoRef} src="" width={VIDEO_WIDTH} />

                            {/* <video ref={outdoorVideoRef} autoPlay loop muted width={VIDEO_WIDTH}>
                                <source src={TestBgOutdoor} type="video/mp4" />
                            </video> */}
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}